module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc2-04-8dcb30955640244c2b490e8d3ca68369.png";